import React from 'react';

import { AccountItem } from '../AccountItem/AccountItem';

export const AccountList = ({ accounts }) => (
    <div>
        {accounts.map((account) => (
            <AccountItem account={account} key={account.guid} />
        ))}
    </div>
);
